// Alcance da gerência comercial em Config › Usuários (#6510, 29/10/2026).
//
// A gerência do Comercial é uma só: quem tem o papel `gerente` (hoje a Talita)
// cuida do Comercial inteiro, inclusive dos parceiros. O papel
// `gerente_parcerias` foi aposentado: não aparece mais para escolha e ninguém
// ativo o tem (o que sobrou dele no código sai na #6520).
//
// Espelhado em supabase/functions/manage-users/index.ts (gerenteAlcanca e
// PAPEIS_ATRIBUIVEIS_PELO_GERENTE): a tela só esconde, quem barra é a edge.
// Se mudar aqui, mude lá.
import { ehDoComercial } from './departamentos.ts';
import type { Profile } from '../../types';

type Alvo = Pick<Profile, 'role' | 'departamento' | 'departamentos' | 'funcao_comercial'>;

/** Papéis que a gerente comercial edita e gerencia sempre. */
export const PAPEIS_GERIDOS_PELO_GERENTE = ['vendedor', 'motoboy', 'parceiro', 'vendedor_parceiro'] as const;

/** Papéis que a gerente comercial pode dar a alguém. */
export const PAPEIS_ATRIBUIVEIS_PELO_GERENTE = ['vendedor', 'analista', 'motoboy', 'parceiro', 'vendedor_parceiro'] as const;

/**
 * A gerente comercial pode editar e gerenciar esta pessoa? Analista só quando é
 * do Comercial (a Júlia, Closer, tem papel `analista`). Os analistas das outras
 * áreas continuam só com o adm.
 */
export const gerenteAlcanca = (alvo: Alvo | null | undefined): boolean =>
  !!alvo && (
    (PAPEIS_GERIDOS_PELO_GERENTE as readonly string[]).includes(alvo.role)
    || (alvo.role === 'analista' && ehDoComercial(alvo))
  );
